import "./styles/lyn-blocks-frontend.scss"
jQuery('.lyn-nav-dropdown').on('click', (el) => {
    // get data target of clicked element
    const button = jQuery(el.currentTarget)
    const target = button.data('target')
    const targetEl = jQuery(`.${ target }`)

    button.toggleClass('shown')
    targetEl.toggleClass('shown')
})
